/* ============================================================
   sm-facets.js — Facettes custom Silumen — v4
   ------------------------------------------------------------
   - "Voir plus / Voir moins" par groupe
   - Recherche intra-facette (listes longues)
   - Tri des valeurs : numerique + temperature (chaud -> froid)
   - Tiroir de filtres plein ecran sur mobile (titre, croix, bouton
     "Voir les N resultats")
   - Feedback de chargement pendant le filtrage AJAX
   - Events GA4 (dataLayer) : facet_click, facet_price, facet_open,
     facet_clear

   Tout est en delegation sur document : le contenu est re-rendu en AJAX
   par theme.AjaxRenderer, ET clone en mobile dans
   #CollectionInlineFilterWrap. Aucun handler n'est attache a un noeud
   precis, aucun noeud conserve en variable.

   ============================================================
   POINTS DE VIGILANCE — ne pas "simplifier" sans relire
   ============================================================
   1. Masquage par CLASSE, jamais en style inline. sm-facets.css est
      genere par build_css.py qui met !important sur chaque declaration :
      un style inline perdrait contre lui. D'ou .sm-is-hidden.

   2. Ecoute en phase CAPTURE + stopPropagation pour la recherche.
      collection-template.js ecoute 'input' ET 'change' sur .filter-form :
      sans ca chaque frappe relance un render AJAX qui vide le champ.

   3. Etat du tiroir = classe .is-active posee par le THEME sur
      .collection-filter__btn. NE JAMAIS tester la geometrie du wrap :
      notre CSS le met en position fixed inset 0 des que
      body.sm-filters-open existe, donc offsetHeight resterait > 0 en
      permanence et le tiroir deviendrait impossible a fermer.

   4. L'observer n'ecoute QUE childList, et il est debranche pendant nos
      propres ecritures (smMutate). Avec attributes:true, nos mutations
      (classList, style.height de resizePanel, injection du chrome)
      relancaient l'observer en boucle : thread principal sature, page
      figee a l'ouverture du tiroir.

   5. Les ticks sont regroupes par requestAnimationFrame (smSchedule) :
      un re-render AJAX emet des dizaines de mutations, on ne veut
      qu'un seul passage.

   6. La barre de filtres sticky se cale a top: 0 dans sm-responsive.css.
      Pas de mesure JS : la barre du mega menu n'est pas sticky en
      mobile, la mesurer decalait la barre vers le bas.
   ============================================================ */
(function () {
  'use strict';

  if (window.__smFacetsInit) return;
  window.__smFacetsInit = true;

  window.dataLayer = window.dataLayer || [];

  var MOBILE_BP = 768;
  var LOADING_TIMEOUT = 6000;   /* filet de securite si l'AJAX echoue */

  /* ============================================================
     Helpers
     ============================================================ */

  /* e.target peut etre un noeud texte ou document : closest() n'existe
     pas partout, on ne veut pas d'exception dans un handler global. */
  function closestEl(node, selector) {
    return (node && node.closest) ? node.closest(selector) : null;
  }

  function root(el) {
    return closestEl(el, '.sm-facets');
  }

  function collectionHandle(el) {
    var r = root(el);
    return (r && r.getAttribute('data-collection')) || '';
  }

  /* Le theme fige la hauteur du .collapsible-content en pixels a
     l'ouverture. Des qu'on change le nombre de lignes visibles (voir
     plus / recherche / tri), il faut la recalculer sinon le contenu est
     coupe. */
  function resizePanel(group) {
    var panel = group.querySelector('.collapsible-content');
    if (!panel || !panel.classList.contains('is-open')) return;
    var inner = panel.querySelector('.collapsible-content__inner');
    if (!inner) return;
    var h = inner.offsetHeight + 'px';
    if (panel.style.height !== h) panel.style.height = h;
  }

  /* Comparaison souple : minuscules, sans accents, espaces normalises.
     "eclairage" doit matcher "Éclairage", "ip 65" doit matcher "IP65". */
  function smNorm(s) {
    return (s || '')
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isFacetSearch(el) {
    return !!(el && el.classList &&
              el.classList.contains('sm-facet__search-input') &&
              closestEl(el, '.sm-facets'));
  }

  function smWrap() {
    return document.getElementById('CollectionInlineFilterWrap');
  }

  function smScope() {
    return document.getElementById('CollectionAjaxContent') || document.body;
  }

  function smGrid() {
    return document.querySelector('.collection-grid__wrapper') ||
           document.getElementById('CollectionAjaxContent');
  }

  function smFilterBtn() {
    return document.querySelector('.collection-filter__btn');
  }

  /* ============================================================
     Voir plus / Voir moins
     ============================================================ */

  document.addEventListener('click', function (e) {
    var btn = closestEl(e.target, '.sm-facets .sm-facet__more');
    if (!btn) return;
    e.preventDefault();

    var group = closestEl(btn, '.sm-facet');
    if (!group) return;

    smMutate(function () {
      if (group.hasAttribute('data-expanded')) {
        group.removeAttribute('data-expanded');
        btn.textContent = btn.getAttribute('data-more');
      } else {
        group.setAttribute('data-expanded', '');
        btn.textContent = btn.getAttribute('data-less');
      }
      resizePanel(group);
    });
  });

  /* ============================================================
     Recherche intra-facette
     ============================================================ */

  function smRunSearch(input) {
    var group = closestEl(input, '.sm-facet');
    if (!group) return;

    var q = smNorm(input.value);

    smMutate(function () {
      /* Pendant la recherche le groupe est force en "tout affiche" ; on
         lui rend son etat voir-plus d'origine quand le champ se vide. */
      if (q) {
        if (!group.hasAttribute('data-searching')) {
          group.setAttribute('data-was-expanded',
                             group.hasAttribute('data-expanded') ? '1' : '0');
        }
        group.setAttribute('data-searching', '');
        group.setAttribute('data-expanded', '');
      } else if (group.hasAttribute('data-searching')) {
        if (group.getAttribute('data-was-expanded') !== '1') {
          group.removeAttribute('data-expanded');
        }
        group.removeAttribute('data-searching');
        group.removeAttribute('data-was-expanded');
      }

      var rows = group.querySelectorAll('[data-sm-value]');
      var hits = 0;

      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        var label = row.getAttribute('data-sm-value');
        if (!label) {
          var t = row.querySelector('.tag__text');
          label = t ? t.textContent : '';
        }
        var ok = !q || smNorm(label).indexOf(q) !== -1;
        row.classList.toggle('sm-is-hidden', !ok);
        row.style.removeProperty('display');  /* ancien masquage inline */
        if (ok) hits++;
      }

      group.setAttribute('data-hits', hits);
      resizePanel(group);
    });
  }

  /* Capture sur document : survit au re-render AJAX et au clone mobile,
     et coupe l'evenement avant qu'il n'atteigne .filter-form. */
  document.addEventListener('input', function (e) {
    if (!isFacetSearch(e.target)) return;
    e.stopPropagation();
    smRunSearch(e.target);
  }, true);

  /* change = blur du champ ; sans ca le theme relance un render en
     sortie de champ et la recherche se reinitialise. */
  document.addEventListener('change', function (e) {
    if (!isFacetSearch(e.target)) return;
    e.stopPropagation();
  }, true);

  /* Croix native de <input type="search"> : evenement 'search', qui ne
     bulle pas -> seule la phase capture le voit. */
  document.addEventListener('search', function (e) {
    if (!isFacetSearch(e.target)) return;
    e.stopPropagation();
    smRunSearch(e.target);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (!isFacetSearch(e.target)) return;
    if (e.key === 'Enter') {              /* sinon submit du filter-form */
      e.preventDefault();
      e.stopPropagation();
    } else if (e.key === 'Escape') {
      /* stopPropagation ici : Echap vide le champ, il ne doit pas
         remonter jusqu'au handler qui ferme le tiroir. */
      e.target.value = '';
      smRunSearch(e.target);
      e.stopPropagation();
    }
  }, true);

  /* ============================================================
     Etat visuel immediat au clic + feedback de chargement
     Le re-render AJAX repose .tag--active depuis Liquid, mais pendant
     le fetch (et si :has() n'est pas supporte) on synchronise ici.
     ============================================================ */

  var smLoadingTimer = null;

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!root(input)) return;
    if (isFacetSearch(input)) return;

    if (input.type === 'checkbox') {
      var row = closestEl(input, '[data-sm-value]');
      if (row) smMutate(function () {
        row.classList.toggle('tag--active', input.checked);
      });
    }

    var g = smGrid();
    if (g) {
      smMutate(function () { g.classList.add('sm-loading'); });
      if (smLoadingTimer) clearTimeout(smLoadingTimer);
      smLoadingTimer = setTimeout(smClearLoading, LOADING_TIMEOUT);
    }
  });

  function smClearLoading() {
    var g = smGrid();
    if (g && g.classList.contains('sm-loading')) {
      smMutate(function () { g.classList.remove('sm-loading'); });
    }
  }

  /* ============================================================
     Tri des valeurs — 'numerique' et 'temperature'
     (alpha / compte sont deja tries en Liquid par sm-facet-group)
     ============================================================ */

  var SM_TEMP_MAP = [
    [/\b2700\s*k\b|\b2400\s*k\b|\b2200\s*k\b/, 2700],
    [/\b3000\s*k\b|chaud|warm/, 3000],
    [/\b3500\s*k\b/, 3500],
    [/\b4000\s*k\b|neutre|naturel/, 4000],
    [/\b5000\s*k\b/, 5000],
    [/\b6000\s*k\b|\b6500\s*k\b|froid|cold|cool/, 6000],
    [/cct|3\s*en\s*1|tricolore|variable|ajustable|selectionnable|dim.?to.?warm/, 990000],
    [/rgb|rgbw|multicolore/, 1000000]
  ];

  function smSortValue(label, mode) {
    var s = smNorm(label);

    if (mode === 'temperature') {
      var k = s.match(/(\d{3,5})\s*k\b/);
      if (k) return parseInt(k[1], 10);
      for (var i = 0; i < SM_TEMP_MAP.length; i++) {
        if (SM_TEMP_MAP[i][0].test(s)) return SM_TEMP_MAP[i][1];
      }
      return 500000;                     /* inconnu : avant CCT et RGB */
    }

    /* numerique : premiere valeur numerique du libelle */
    var m = s.replace(/[\u00a0\u202f]/g, ' ').match(/-?\d+(?:[.,]\d+)?/);
    return m ? parseFloat(m[0].replace(',', '.')) : Number.POSITIVE_INFINITY;
  }

  function smReorderGroup(group) {
    var mode = group.getAttribute('data-sm-tri');
    if (mode !== 'numerique' && mode !== 'temperature') return;

    var list = group.querySelector('.sm-checks, .sm-pills, .sm-swatches');
    if (!list) return;

    var items = Array.prototype.slice.call(list.children);
    if (items.length < 2) return;

    var sorted = items.slice().sort(function (a, b) {
      return smSortValue(a.getAttribute('data-sm-value'), mode) -
             smSortValue(b.getAttribute('data-sm-value'), mode);
    });

    /* idempotence : deja trie -> aucune mutation */
    var same = true;
    for (var i = 0; i < sorted.length; i++) {
      if (sorted[i] !== items[i]) { same = false; break; }
    }
    if (same) return;

    var frag = document.createDocumentFragment();
    for (var j = 0; j < sorted.length; j++) frag.appendChild(sorted[j]);
    list.appendChild(frag);

    var seuil = parseInt(group.getAttribute('data-sm-seuil'), 10) || 0;
    if (seuil > 0) {
      for (var n = 0; n < sorted.length; n++) {
        sorted[n].classList.toggle('sm-extra', n >= seuil);
      }
    }
    resizePanel(group);
  }

  function smReorderAll() {
    var groups = document.querySelectorAll(
      '.sm-facet[data-sm-tri="numerique"], .sm-facet[data-sm-tri="temperature"]');
    for (var i = 0; i < groups.length; i++) smReorderGroup(groups[i]);
  }

  /* ============================================================
     Tiroir de filtres mobile (plein ecran)
     ============================================================ */

  function smSheetOpen() {
    if (window.innerWidth > MOBILE_BP) return false;
    var btn = smFilterBtn();
    if (btn) return btn.classList.contains('is-active');
    var w = smWrap();                    /* repli si le bouton a change */
    return !!(w && w.querySelector('.filter-wrapper'));
  }

  function smCloseSheet() {
    var btn = smFilterBtn();
    if (btn) btn.click();                /* mecanisme du theme */
    setTimeout(smTick, 30);              /* ne pas attendre l'observer */
  }

  /* Injecte l'en-tete et le bouton d'application dans le clone mobile.
     Idempotent : ne cree que ce qui manque, n'ecrit le libelle que s'il
     a change. Appele UNIQUEMENT depuis smTick, donc deja sous smMutate. */
  function smSheetChrome() {
    var w = smWrap();
    if (!w) return;

    if (!w.querySelector('.sm-sheet-head')) {
      var head = document.createElement('div');
      head.className = 'sm-sheet-head';

      var title = document.createElement('span');
      title.textContent = 'Filtrer';

      var close = document.createElement('button');
      close.type = 'button';
      close.className = 'sm-sheet-close';
      close.setAttribute('aria-label', 'Fermer les filtres');
      close.innerHTML = '&times;';
      close.addEventListener('click', smCloseSheet);

      head.appendChild(title);
      head.appendChild(close);
      w.insertBefore(head, w.firstChild);
    }

    var apply = w.querySelector('.sm-sheet-apply');
    if (!apply) {
      apply = document.createElement('button');
      apply.type = 'button';
      apply.className = 'sm-sheet-apply';
      apply.addEventListener('click', smCloseSheet);
      w.appendChild(apply);
    }

    var cnt = document.querySelector('.collection-filter__item--count');
    var n = cnt
      ? (cnt.textContent.match(/\d[\d\s\u00a0\u202f.,]*/) || [''])[0].replace(/\D/g, '')
      : '';
    var label = n ? 'Voir les ' + n + ' résultats' : 'Voir les résultats';
    if (apply.textContent !== label) apply.textContent = label;
  }

  function smSyncSheet() {
    var open = smSheetOpen();
    if (open) smSheetChrome();
    if (document.body.classList.contains('sm-filters-open') !== open) {
      document.body.classList.toggle('sm-filters-open', open);
    }
  }

  /* Echap ferme le tiroir (le handler capture de la recherche a deja
     coupe l'evenement si le focus est dans un champ de recherche). */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (document.body.classList.contains('sm-filters-open')) smCloseSheet();
  });

  /* ============================================================
     GA4 — dataLayer
     ============================================================ */

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!root(input)) return;
    if (isFacetSearch(input)) return;

    var group = closestEl(input, '.sm-facet');
    var facetName = group ? group.getAttribute('data-sm-facet') : '';

    if (closestEl(input, '.price-range')) {
      window.dataLayer.push({
        event: 'facet_price',
        facet_collection: collectionHandle(input),
        facet_group: facetName || 'prix'
      });
      return;
    }

    if (input.type !== 'checkbox') return;

    var row = closestEl(input, '[data-sm-value]');
    window.dataLayer.push({
      event: 'facet_click',
      facet_collection: collectionHandle(input),
      facet_group: facetName || '',
      facet_value: row ? row.getAttribute('data-sm-value') : input.value,
      facet_action: input.checked ? 'add' : 'remove'
    });
  });

  document.addEventListener('click', function (e) {
    var toggle = closestEl(e.target, '.sm-facets .sm-facet__toggle');
    if (!toggle) return;

    var group = closestEl(toggle, '.sm-facet');
    /* is-open est posee par theme.collapsibles APRES ce handler :
       l'etat lu ici est celui d'avant clic, on l'inverse. */
    var willOpen = !toggle.classList.contains('is-open');

    window.dataLayer.push({
      event: 'facet_open',
      facet_collection: collectionHandle(toggle),
      facet_group: group ? group.getAttribute('data-sm-facet') : '',
      facet_state: willOpen ? 'open' : 'close'
    });
  });

  document.addEventListener('click', function (e) {
    var clear = closestEl(e.target, '.sm-facets [data-action="clear-filters"]');
    if (!clear) return;

    window.dataLayer.push({
      event: 'facet_clear',
      facet_collection: collectionHandle(clear)
    });
  });

  /* ============================================================
     Observer — debounce rAF + coupe pendant nos propres ecritures
     ============================================================ */

  var smObserver = null;
  var smQueued = false;
  var smDepth = 0;

  function smObserve() {
    if (!smObserver) return;
    smObserver.observe(smScope(), { childList: true, subtree: true });
  }

  /* smMutate est reentrant : seul le niveau le plus externe rebranche
     l'observer, sinon un appel imbrique le reactiverait trop tot. */
  function smMutate(fn) {
    if (smObserver && smDepth === 0) smObserver.disconnect();
    smDepth++;
    try { fn(); }
    finally {
      smDepth--;
      if (smDepth === 0) smObserve();
    }
  }

  function smTick() {
    smMutate(function () {
      smReorderAll();
      smSyncSheet();
      var g = smGrid();
      if (g && g.classList.contains('sm-loading')) {
        g.classList.remove('sm-loading');
      }
    });
  }

  function smSchedule() {
    if (smQueued) return;
    smQueued = true;
    requestAnimationFrame(function () {
      smQueued = false;
      smTick();
    });
  }

  function boot() {
    smTick();

    /* le theme met un temps a poser .is-active : on resynchronise apres */
    document.addEventListener('click', function (e) {
      if (closestEl(e.target, '.collection-filter__btn')) {
        setTimeout(smTick, 50);
      }
    });

    smObserver = new MutationObserver(smSchedule);
    smObserve();

    window.addEventListener('resize', smSchedule, { passive: true });
    window.addEventListener('orientationchange', smSchedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();